<template>
	<div class="page">
		<div class="form">
			<div class="tit">
				<div class="titL">基本信息</div>
				<div class="titR"></div>
			</div>
			<div class="con">
				<el-form :inline="true" :model="user" class="demo-form-inline" ref="form1" label-width="formLabelWidth"
					:rules="userRules">
					<el-row>
						<el-col :span="6">
							<el-form-item label="姓名：" :label-width="formLabelWidth" prop="nick_name">
								<el-input v-model="user.nick_name" placeholder="请输入" size="small"></el-input>
							</el-form-item>
						</el-col>
						<!-- <el-col :span="6">
							<el-form-item label="顾客编号：" :label-width="formLabelWidth" prop="birthday">
								user_no
							</el-form-item>
						</el-col> -->
						<el-col :span="6">
							<el-form-item label="生日：" :label-width="formLabelWidth" prop="birthday">
								<el-date-picker v-model="user.birthday" type="date" size="small" placeholder="选择日期"
									:picker-options="{ disabledDate(time) { return new Date().getTime() < time.getTime() } }"
									@change="changeUserDate" style="width:200px;">
								</el-date-picker>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="年龄：" :label-width="formLabelWidth">
								<el-input :value="user.birthday ? $public.FAge(user.birthday)[0] + '岁' : ''" disabled
									placeholder="" size="small"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="会员备注：" :label-width="formLabelWidth">
								<el-input v-model="user.remark" placeholder="请输入" size="small"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="6">
							<el-form-item label="手机号：" :label-width="formLabelWidth" prop="user_mobile">
								<el-input v-model="user.user_mobile" placeholder="请输入" size="small"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="性别：" :label-width="formLabelWidth" prop="sex">
								<el-radio-group v-model="user.sex" size="small">
									<el-radio :label="'男'">男</el-radio>
									<el-radio :label="'女'">女</el-radio>
								</el-radio-group>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="邮箱：" :label-width="formLabelWidth" prop="user_email">
								<el-input v-model="user.user_email" placeholder="请输入" size="small"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="年龄区间" :label-width="formLabelWidth" prop="age_group">
								<el-select v-model="age_group" placeholder="请选择" @change="age">
									<el-option v-for="item in options" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>

					</el-row>
					<el-row>
						<el-col :span="6">
							<el-form-item label="家庭住址：" :label-width="formLabelWidth" prop="home_address">
								<el-input type="textarea" rows="3" v-model="user.home_address" placeholder="请输入"
									size="small"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="紧急联系人：" :label-width="formLabelWidth" prop="urgent_user">
								<el-input rows="3" v-model="user.urgent_user" placeholder="请输入" size="small"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="紧急电话：" :label-width="formLabelWidth" prop="urgent_user_mobile">
								<el-input rows="3" v-model="user.urgent_user_mobile" placeholder="请输入"
									size="small"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="客户来源" :label-width="formLabelWidth" prop="user_source">
								<el-select v-model="user_source" placeholder="请选择" @change="source">
									<el-option v-for="item in option" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
			</div>
		</div>
		<div class="form">
			<div class="tit">
				<div class="titL">宠物资料</div>
				<div class="titR"></div>
			</div>
			<div class="con">
				<el-form :inline="true" :model="pet" class="demo-form-inline" ref="form2" label-width="formLabelWidth"
					:rules="petRules">
					<el-row>
						<el-col :span="6">
							<el-form-item label="宠物昵称：" :label-width="formLabelWidth" prop="nick_name">
								<el-input v-model="pet.nick_name" placeholder="请输入" size="small"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="5">
							<el-form-item label="种类：" :label-width="formLabelWidth" prop="pet_type">
								<el-radio-group v-model="pet.pet_type" @change="typeChange" size="small">
									<el-radio :label="'2'">犬</el-radio>
									<el-radio :label="'1'">猫</el-radio>
								</el-radio-group>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="品种：" :label-width="formLabelWidth" prop="category_id">
								<el-select class="select" filterable v-model="pet.category_id" placeholder="请选择品种"
									size="small" style="width:200px;">
									<el-option v-for="item in typeList" :key="item.id" :label="item.label" :value="item.id">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="7">
							<el-form-item label="性别：" :label-width="formLabelWidth" prop="pet_sex">
								<el-radio-group v-model="pet.pet_sex" size="small">
									<el-radio :label="'公'" style="margin-right:8px;">公</el-radio>
									<el-radio :label="'母'" style="margin-right:8px;">母</el-radio>
									<el-radio :label="'绝育弟弟'" style="margin-right:8px;">绝育公</el-radio>
									<el-radio :label="'绝育妹妹'" style="margin-right:8px;">绝育母</el-radio>
								</el-radio-group>
							</el-form-item>
						</el-col>
					</el-row>
					<!-- <el-row>
						
					</el-row> -->
					<el-row>
						<el-col :span="6">
							<el-form-item label="类型：" :label-width="formLabelWidth" prop="pet_varieties">
								<el-radio-group v-model="pet.pet_varieties" size="small">
									<el-radio v-if="pet.pet_type === '2'" :label="'11'">普通犬</el-radio>
									<el-radio v-if="pet.pet_type === '2'" :label="'12'">特种犬</el-radio>
									<el-radio v-if="pet.pet_type === '1'" :label="'21'">普通猫</el-radio>
									<el-radio v-if="pet.pet_type === '1'" :label="'22'">特种猫</el-radio>
								</el-radio-group>
							</el-form-item>
						</el-col>
						<el-col :span="5">
							<el-form-item label="毛发：" :label-width="formLabelWidth">
								<el-radio-group v-model="pet.pet_features" size="small">
									<el-radio :label="'1'">短毛</el-radio>
									<el-radio :label="'2'">长毛</el-radio>
								</el-radio-group>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="颜色：" :label-width="formLabelWidth">
								<el-select class="select" filterable allow-create default-first-option
									v-model="pet.pet_color" placeholder="请选择毛色" size="small" style="width:200px;">
									<el-option v-for="item in colorList" :key="item._id" :label="item.name"
										:value="item.name">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="7">
							<el-form-item label="已免疫：" :label-width="formLabelWidth">
								<el-radio-group v-model="pet.immunization" size="small">
									<el-radio :label="1">是</el-radio>
									<el-radio :label="0">否</el-radio>
								</el-radio-group>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="6" v-if="pet.pet_type === '2'">
							<el-form-item label="犬证编号：" :label-width="formLabelWidth" size="small">
								<el-input v-model="pet.pet_certificate_no" placeholder="请输入"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="5">
							<el-form-item label="生日：" :label-width="formLabelWidth" prop="bron_date">
								<el-date-picker v-model="pet.bron_date" type="date" size="small" placeholder="选择日期"
									:picker-options="{ disabledDate(time) { return new Date().getTime() < time.getTime() } }"
									@change="changePetDate" style="width:150px;">
								</el-date-picker>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="年龄：" :label-width="formLabelWidth">
								<el-input
									:value="pet.bron_date ? $public.FAge(pet.bron_date)[0] + '岁' + $public.FAge(pet.bron_date)[1] + '月' : ''"
									placeholder="" disabled size="small"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="7">
							<el-form-item label="备注：" :label-width="formLabelWidth" prop="remark">
								<el-input v-model="pet.remark" placeholder="请输入" size="small"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="6">
							<el-form-item label="宠物体重：" :label-width="formLabelWidth" prop="weight" required>
								<el-input rows="3" v-model="pet.weight" placeholder="请输入" size="small" style="width:193px;"
									@input="changeWeight">
									<template slot="append">kg</template>
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="18">
							<el-form-item label="体重备注：" :label-width="formLabelWidth">
								<el-input v-model="pet.weight_remark" placeholder="请输入" size="small"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="6">
							<el-form-item label="芯片编号：" :label-width="formLabelWidth" prop="eprom_no">
								<el-input rows="3" v-model="pet.eprom_no" placeholder="请输入" size="small"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="18">
							<el-form-item label="性格(多选)：" :label-width="formLabelWidth">
								<el-checkbox-group v-model="characters" @change="changeCharacters">
									<el-checkbox v-for="character in characterList" :label="character" :key="character"
										size="small">{{ character }}</el-checkbox>
								</el-checkbox-group>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="index === 1 ? 5 : 6" v-for="(item, index) in tool_num" :key='index'>
							<el-form-item :label="'用具编号' + (index + 1) + '：'" :label-width="formLabelWidth" prop="tool_num">
								<el-input rows="3" v-model="item.name" placeholder="请输入" size="small"
									:style="{ width: index === 1 ? '150px' : 'auto' }"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
			</div>
		</div>
		<el-row style="padding:80px;">
			<el-button type="primary" @click="submit">保存 基本信息和宠物资料</el-button>
			<el-button type="danger" @click="submit1">仅保存 基本信息</el-button>
		</el-row>
	</div>
</template>

<script>
export default {
	data() {
		var validateTel = (rule, value, callback) => {
			if (!this.$public.isTel(value)) {
				callback(new Error('手机号输入有误'));
			} else {
				callback();
			}
		};
		var isMail = (rule, value, callback) => {
			if (value == '') {
				callback();
			} else
				if (!this.$public.isMail(value)) {
					callback(new Error('邮箱输入有误'));
				} else {
					callback();
				}
		};
		return {
			formLabelWidth: '90px',
			characters: [],
			characterList: ['安静', '温顺', '暴躁', '活泼', '对陌生人不友善'],
			typeList: [],
			typeList1: [],
			typeList2: [],
			colorList: [],
			// hairList:[],
			// specialList:[],
			options: [{
          value: '18-25',
          label: '18-25'
        }, {
          value: '25-30',
          label: '25-30'
        }, {
          value: '30-35',
          label: '30-35'
        }, {
          value: '35-40',
          label: '35-40'
        }, {
          value: '45-50',
          label: '45-50'
        }, {
          value: '50-1000',
          label: '50以上'
        }],
        age_group: '',
		user_source:'',//客户来源
		option: [{
          value: '自然流量',
          label: '自然流量'
        }, {
          value: '宠物广告',
          label: '宠物广告'
        }, {
          value: '抖音',
          label: '抖音'
        }, {
          value: '小红书',
          label: '小红书'
        }, {
          value: '团购',
          label: '团购'
        },{
          value: '官方直播',
          label: '官方直播'
        },{
          value: '其它',
          label: '其它'
        },
	],
			user: {
				"user_mobile": "",
				"nick_name": "",
				"avatar_pic": "",
				"user_email": "",
				"user_address": "",
				"sex": "",
				"birthday": "",
				"user_type": 0,
				"home_address": "",
				"urgent_user": "",
				"urgent_user_mobile": "",
				"remark": "",
				"age_group": [],
				"user_source":''
			},
			pet: {
				"nick_name": "",
				"eprom_no": "",  // 芯片号
				"pet_type": "2",
				"category_id": "",
				"category_name": "",
				"pet_features": "",  // 0: 不限制 1:短毛 2:长毛
				"pet_varieties": "",  // 0: 不限制 11:普通狗 12:特种犬 21:普通猫 22:特种猫
				"pet_certificate_no": "",  // 宠物证件编号
				"character": "",  // 性格
				"pet_sex": "",
				"pet_color": "",
				"remark": "",
				"hs_pet": true,  // 是否花生宠物
				"sterilization": 0,  // 绝育
				"immunization": 0,  // 免疫
				"bron_date": "",  // 生日
				"home_date": "",  // 到家时间
				"avatar_pic": "",  // 缩略图
				"tool_num": "",  // 用具编号
				"weight": '',
				"weight_remark": "",
			},
			userRules: {
				nick_name: [{
					required: true,
					message: '请输入昵称',
					trigger: 'blur'
				}],
				user_mobile: [{
					required: true,
					validator: validateTel,
					trigger: 'blur'
				}],
				user_email: [{
					validator: isMail,
					trigger: 'blur'
				}],
				age_group: [{
					required: true,
					message: '请选择年龄区间',
					trigger: 'blur'
				}],
				user_source: [{
					required: true,
					message: '请选择客户来源',
					trigger: 'blur'
				}],
			},
			petRules: {
				nick_name: [{
					required: true,
					message: '请输入宠物昵称',
					trigger: 'blur'
				}],
				pet_type: [{
					required: true,
					message: '请选择宠物种类',
					trigger: 'blur'
				}],
				category_id: [{
					required: true,
					message: '请输入宠物品种',
					trigger: 'blur'
				}],
				pet_sex: [{
					required: true,
					message: '请选择宠物性别',
					trigger: 'blur'
				}],
				weight: [{
					required: true,
					message: '请输入宠物体重',
					trigger: 'blur'
				}],
			},
			tool_num: [{ name: '' }, { name: '' }, { name: '' }]
		}
	},
	computed: {
		saleList() {
			return this.$store.state.mendian.saleList;
		},
	},
	mounted() {
		// 获取猫狗分类
		let params = {
			category: '活体'
		}
		this.$http.get('/api/Product/Category/Tree', params).then(res => {
			if (res.code === 0) {
				for (let i = 0; i < res.data[0].children.length; i++) {
					let item = res.data[0].children[i];
					if (item.id === '603f7255664b790a9c7d4f61') {
						this.typeList1 = item.children;
					}
					if (item.id === '603f7255664b790a9c7d4f62') {
						this.typeList2 = item.children;
					}
				}
				this.getTypeList()
			}
		})
		// 获取猫狗颜色
		this.getColorList();
		// this.getHairList();
		// this.getSpecialList();
	},
	methods: {
		age(e){
          
		   this.user.age_group=e.split("-")
		   console.log(this.user.age_group,"this.user.age_group");
		},
		source(e){
		
			this.user.user_source=e
			console.log(this.user.user_source,"eeeeeeeee");
		},
		// 修改生日
		changeUserDate(a) {
			if (this.$public.isNull(a)) {
				this.user.birthday = '';
			} else {
				this.user.birthday = a;
			}
		},
		// 切换猫狗
		typeChange() {
			this.getTypeList();
			this.pet.category_id = '';
			this.pet.pet_special = '';
			this.pet.pet_certificate_no = ''
		},
		// 修改生日
		changePetDate(a) {
			if (a == null) {
				this.pet.bron_date = '';
			} else {
				this.pet.bron_date = new Date(a).getTime();
			}
		},
		// 修改体重
		changeWeight() {
			this.pet.weight = this.$public.replaceGoodsDosage(this.pet.weight)
		},
		// 改变性格
		changeCharacters() {
			console.log(this.characters)
		},
		// 提交用户信息
		submit() {
			// if (this.value ==[]) {
			// 	this.$message({
			// 		type: "error",
			// 		message: "顾客年龄区间不完整",
			// 	});
			// 	return;
			// }
			var tool_num = '';
			this.tool_num.forEach(item => {
				if (!this.$public.isNull(item.name)) {
					tool_num = tool_num + item.name + ','
				}
			})
			tool_num = tool_num.substr(0, tool_num.length - 1)
			this.$refs['form1'].validate((v) => {
				if (v) {
					this.$refs['form2'].validate((valid) => {
						if (valid) {
							let category_name = '';
							if (this.pet.pet_type === '1') {
								category_name = this.$public.getMatchingItem(this.typeList1, 'id', this.pet.category_id).label;
							} else if (this.pet.pet_type === '2') {
								category_name = this.$public.getMatchingItem(this.typeList2, 'id', this.pet.category_id).label;
							}
							let pet_sex = '';
							let sterilization = 0;
							if (this.pet.pet_sex === '公') { pet_sex = '公'; sterilization = 0 }
							if (this.pet.pet_sex === '母') { pet_sex = '母'; sterilization = 0 }
							if (this.pet.pet_sex === '绝育弟弟') { pet_sex = '公'; sterilization = 1 }
							if (this.pet.pet_sex === '绝育妹妹') { pet_sex = '母'; sterilization = 1 }
							let params = {
								"user_mobile": this.user.user_mobile,
								"nick_name": this.user.nick_name,
								"avatar_pic": '',
								"user_email": this.user.user_email,
								"user_address": this.user.user_address,
								"home_address": '',
								"sex": this.user.sex,
								"birthday": this.$public.FTimeStr10(this.user.birthday),
								"user_type": this.user.user_type,
								"urgent_user": this.user.urgent_user,
								"urgent_user_mobile": this.user.urgent_user_mobile,
								"remark": this.user.remark,
								"age_group": this.user.age_group,
								"user_source":this.user.user_source,
								pet_info: {
									"nick_name": this.pet.nick_name,
									"eprom_no": this.pet.eprom_no,  // 芯片号
									"pet_type": this.pet.pet_type,
									"category_id": this.pet.category_id,
									"category_name": category_name,
									"pet_features": this.pet.pet_features,  // 0: 不限制 1:短毛 2:长毛
									"pet_varieties": this.pet.pet_varieties,  // 0: 不限制 11:普通狗 12:特种犬 21:普通猫 22:特种猫
									"pet_certificate_no": this.pet.pet_type === '2' ? this.pet.pet_certificate_no : '',  // 宠物证件编号
									"character": this.characters.join(','),  // 性格
									"pet_sex": pet_sex,
									"pet_color": this.pet.pet_color,
									"remark": this.pet.remark,
									"hs_pet": false,  // 是否花生宠物
									"sterilization": sterilization,  // 绝育
									"immunization": this.pet.immunization,  // 免疫
									"bron_date": this.$public.FTime(this.pet.bron_date, 'YYYY-MM-DD'),  // 生日
									"home_date": '',  // 到家时间
									"avatar_pic": '',  // 缩略图
									"tool_num": tool_num,  // 用具编号
									"weight": Number(this.pet.weight),
									"weight_remark": this.pet.weight_remark,
								}
							}
							let loading = this.$loading();
							this.$http.post('/api/Member/InsertAndPet', params).then(res => {
								if (res.code == 0) {
									this.$message({
										message: '添加成功',
										type: 'success'
									});
									this.user = {
										"user_mobile": "",
										"nick_name": "",
										"avatar_pic": "",
										"user_email": "",
										"user_address": "",
										"sex": "",
										"birthday": "",
										"user_type": 0,
										"home_address": "",
										"urgent_user": "",
										"urgent_user_mobile": "",
										"remark": "",
										"user_source":''
									}
									this.pet = {
										"nick_name": "",
										"eprom_no": "",  // 芯片号
										"pet_type": "2",
										"category_id": "",
										"category_name": "",
										"pet_features": "",  // 0: 不限制 1:短毛 2:长毛
										"pet_varieties": "",  // 0: 不限制 11:普通狗 12:特种犬 21:普通猫 22:特种猫
										"pet_certificate_no": "",  // 宠物证件编号
										"character": "",  // 性格
										"pet_sex": "",
										"pet_color": "",
										"remark": "",
										"hs_pet": true,  // 是否花生宠物
										"sterilization": 0,  // 绝育
										"immunization": 0,  // 免疫
										"bron_date": "",  // 生日
										"home_date": "",  // 到家时间
										"avatar_pic": "",  // 缩略图
										"tool_num": "",  // 用具编号
										"weight": '',
										"weight_remark": "",
									}
									this.tool_num = [{ name: '' }, { name: '' }, { name: '' }];
									loading.close()
									if (this.saleList.length > 0) {
										// this.$message({
										// 	message: '消费列表中已录入商品，请先挂单或重置',
										// 	type: 'error'
										// });
										// this.valueVip = ''
										console.log("有客户占用工作台")
										return;
									} else {
										this.$store.commit("setCurNavIndex_mendian", { title: '工作台', path: '/mendian/shouyin' })
										this.$router.replace({ path: '/mendian/shouyin' })
										this.$store.commit("mendian/set_isSanke", false)
										this.$store.commit("mendian/set_userInfo", res.data)
										this.$store.commit("mendian/set_curPetId", res.data.pets_info[0]?res.data.pets_info[0]._id:"")
										// this.$store.commit("mendian/set_curPetId", res.data.pets_info[0]._id) 修改bug
									}
								}
								loading.close()
							})
						}
					});
				}
			})
		},
		submit1() {
			// if (this.value== []) {
			// 	this.$message({
			// 		type: "error",
			// 		message: "顾客年龄区间不完整",
			// 	});
			// 	return;
			// }
			
			this.$refs['form1'].validate((valid) => {
				if (valid) {
					let params = {
						"user_mobile": this.user.user_mobile,
						"nick_name": this.user.nick_name,
						"avatar_pic": '',
						"user_email": this.user.user_email,
						"user_address": this.user.user_address,
						"home_address": '',
						"sex": this.user.sex,
						"birthday": this.$public.FTimeStr10(this.user.birthday),
						"user_type": this.user.user_type,
						"urgent_user": this.user.urgent_user,
						"urgent_user_mobile": this.user.urgent_user_mobile,
						"remark": this.user.remark,
						"age_group": this.user.age_group,
						"user_source":this.user.user_source
					}
					let loading = this.$loading();
					this.$http.post('/api/Member/Insert', params).then(res => {
						if (res.code == 0) {
							this.$message({
								message: '添加成功',
								type: 'success'
							});
							this.user = {
								"user_mobile": "",
								"nick_name": "",
								"avatar_pic": "",
								"user_email": "",
								"user_address": "",
								"sex": "",
								"birthday": "",
								"user_type": 0,
								"home_address": "",
								"urgent_user": "",
								"urgent_user_mobile": "",
								"remark": "",
								"age_group": [],
								"user_source":''
							}
							this.pet = {
								"nick_name": "",
								"eprom_no": "",  // 芯片号
								"pet_type": "2",
								"category_id": "",
								"category_name": "",
								"pet_features": "",  // 0: 不限制 1:短毛 2:长毛
								"pet_varieties": "",  // 0: 不限制 11:普通狗 12:特种犬 21:普通猫 22:特种猫
								"pet_certificate_no": "",  // 宠物证件编号
								"character": "",  // 性格
								"pet_sex": "",
								"pet_color": "",
								"remark": "",
								"hs_pet": true,  // 是否花生宠物
								"sterilization": 0,  // 绝育
								"immunization": 0,  // 免疫
								"bron_date": "",  // 生日
								"home_date": "",  // 到家时间
								"avatar_pic": "",  // 缩略图
								"tool_num": "",  // 用具编号
								"weight": '',
								"weight_remark": "",
							}
							this.tool_num = [{ name: '' }, { name: '' }, { name: '' }];
							loading.close()
							if (this.saleList.length > 0) {
								// this.$message({
								// 	message: '消费列表中已录入商品，请先挂单或重置',
								// 	type: 'error'
								// });
								// this.valueVip = ''
								console.log("有客户占用工作台")
								return;
							} else {
								this.$store.commit("setCurNavIndex_mendian", { title: '工作台', path: '/mendian/shouyin' })
								this.$router.replace({ path: '/mendian/shouyin' })
								this.$store.commit("mendian/set_isSanke", false)
								this.$store.commit("mendian/set_userInfo", res.data)
								this.$store.commit("mendian/set_curPetId", '')
							}
						}
						loading.close()
					})
				}
			});
		},
		// 获取品种列表
		getTypeList() {
			if (this.pet.pet_type === '1') {
				this.typeList = this.typeList1;
			} else if (this.pet.pet_type === '2') {
				this.typeList = this.typeList2;
			}
		},
		// // 获取毛发
		// getHairList() {
		// 	this.$http.get(process.env.VUE_APP_Url2+'api/product/pet/hair').then(res => {
		// 		if (res.code == 0) {
		// 			this.hairList = res.data;
		// 		}
		// 	})
		// },
		// // 获取特种
		// getSpecialList() {
		// 	this.$http.get(process.env.VUE_APP_Url2+'api/product/pet/Special').then(res => {
		// 		if (res.code == 0) {
		// 			this.specialList = res.data;
		// 		}
		// 	})
		// },
		// 获取毛色列表
		getColorList() {
			let params = {
				"keyword": "",
				"pageIndex": 1,
				"pageSize": 1000
			}
			this.$http.post('/api/DataCenter/List', params).then(res => {
				if (res.code == 0) {
					this.colorList = res.data.data;
				}
			})
		},
	}
}
</script>

<style lang="scss" scoped>
.page {
	background-color: #fff;

	::v-deep .el-form-item__label {
		padding-right: 0;
	}

	.form {
		.tit {
			display: flex;
			justify-content: space-between;
			padding: 20px;

			.titL {
				font-size: 16px;
				font-weight: bold;
				color: $fontColor;
				border-left: 3px solid $mainColor;
				padding-left: 10px;
				line-height: 24px;
				height: 24px;
			}

			.titR {}
		}

		.con {
			padding: 0 10px 0 10px;
		}
	}
}</style>
